import { render, staticRenderFns } from "./WhitelistPage.vue?vue&type=template&id=0c044f1e&scoped=true&"
import script from "./WhitelistPage.vue?vue&type=script&lang=js&"
export * from "./WhitelistPage.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistPage.vue?vue&type=style&index=0&id=0c044f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c044f1e",
  null
  
)

export default component.exports